import React, { FC, useEffect, useRef } from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { useBarcodeTimer } from '../../hooks/use-barcode-timer';

interface BarcodeTimerContainerProps {
  onClose: () => void;
}

export const BarcodeTimerContainer: FC<BarcodeTimerContainerProps> = ({ onClose }) => {
  const { formattedMinutes, expired } = useBarcodeTimer();

  // Close the drawer when the barcode session expires.
  // Use a ref to ensure we only call onClose once.
  const expiredClosedRef = useRef(false);
  useEffect(() => {
    if (expired && !expiredClosedRef.current) {
      expiredClosedRef.current = true;
      onClose();
    }
  }, [expired, onClose]);

  return (
    <Typography color="subtle">
      {expired ? 'This session has expired.' : `This session will expire in ${formattedMinutes}.`}
    </Typography>
  );
};

export default BarcodeTimerContainer;
